// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__bivyI","head":"Table_head__CFS9a","col":"Table_col__3BaXh"};